import React from 'react';
import styled from 'styled-components';
import { ManageSecondHeading } from './EsperBenefitsHome';
import { SectionParent, H1 } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { StaticQuery, graphql } from 'gatsby';
import { Title } from './HomepageSectionOne';
import Geekwire from '../../../assets/v2/geekwire_logo.svg';
import arrow from '../../../assets/v2/arrow-blog.svg';

const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #f6f8fb;
`;

const CurrentUpdatesSection = styled(Section)`
  background-color: #f6f8fb;
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  @media (max-width: 520px) {
    padding: 1rem;
  }
`;

const HeaderImgTile = styled(LazyLoadImage)`
  border-radius: 5px 5px 0px 0px;
  width: 100%;
  @media (max-width: 520px) {
    width: 100%;
  }
`;

const PostTitle = styled.h1`
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  margin: 1rem 2rem 0.5rem 2rem;
  font-stretch: normal;
  line-height: normal;
  /* height: 3em; */
  letter-spacing: normal;
  color: #313133;
  min-height: 3rem;
  @media (max-width: 1250px) {
    min-height: 5rem;
  }
  @media (max-width: 768px) {
    font-size: 18px;
    margin: 1rem 1rem 0.5rem 1rem;
  }
  @media (max-width: 520px) {
    min-height: unset;
  }
`;

const PostArticle = styled.article`
  height: 100%;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #e3e5e7;
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  }
  .post-excerpt {
    margin-left: 2rem;
    color: #585858;
    p {
      font-size: 14px;
      color: #585858;
    }
    margin-right: 2rem;
    margin-bottom: 2rem;
  }
`;

const CurrentUpdatesGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding-top: 2rem;
  padding-bottom: 3rem;
  /* flex-wrap: wrap; */
  width: 100%;
  grid-gap: 2rem;
  justify-content: center;
  @media (max-width: 520px) {
    padding-top: 0rem;
    padding-bottom: 4rem;
    margin-top: 1rem;
    margin-right: 0rem;
    margin-right: 0rem;
    grid-gap: 2rem 0rem;
  }
`;

const PostTile = styled.a`
  grid-column: span 4;
  height: fit-content;
  @media (max-width: 1024px) {
    grid-column: span 6;
  }
  @media (max-width: 600px) {
    grid-column: span 12;
  }
`;
const PostTileWrapper = styled.div`
  grid-column: span 4;
  @media (max-width: 1024px) {
    grid-column: span 6;
  }
  @media (max-width: 600px) {
    grid-column: span 12;
  }
`;
const PostLink = styled.a`
  width: fit-content;
  display: grid;
  text-decoration: none;
  justify-items: start;
  grid-column: span 4;
  padding-bottom: 1.5rem;

  cursor: pointer;
  :after {
    content: '';
    display: block;
    width: 0;
    height: 4px;
    border-radius: 8px;
    background: #745dbf;
    transition: width 0.3s;
  }

  :hover::after {
    width: 100%;
    border-radius: 8px;
  }
  @media (max-width: 520px) {
    padding-bottom: 0.5rem;
  }
`;
const LinkWrapper = styled.div`
  display: flex;
`;

const LinkText = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.36px;
  color: #2d2b33;
  margin-right: 1rem;
`;

const ArrowHolder = styled.img`
  width: fit-content;
`;

export default () => (
  <StaticQuery
    query={graphql`
      query BlogQuery {
        allPost: allPost {
          edges {
            node {
              id
              title {
                rendered
              }
              link
              excerpt {
                rendered
                protected
              }
              featuredImage
            }
          }
        }
      }
    `}
    render={(data: any) => (
      <CurrentUpdatesSection>
        <ManageSecondHeading>
          <Title style={{ color: '#2d2b33' }}>Current Updates</Title>
        </ManageSecondHeading>
        <CurrentUpdatesGridContainer>
          {data.allPost.edges.map((item: any, index: number) => (
            <PostTileWrapper key={item.node.link}>
              {index === 0 && (
                <PostLink
                  href="https://blog.esper.io/"
                  target="_blank"
                  rel="noreferrer noopener"
                  style={{ color: '#2d2b33' }}
                >
                  <LinkWrapper>
                    <LinkText>Blog</LinkText>
                    <ArrowHolder alt="Esper Arrow" src={arrow} />
                  </LinkWrapper>
                </PostLink>
              )}
              {index === 1 && (
                <PostLink
                  href="https://blog.esper.io/category/release-notes"
                  target="_blank"
                  rel="noreferrer noopener"
                  style={{ color: '#2d2b33' }}
                >
                  <LinkWrapper>
                    <LinkText>Release</LinkText>
                    <ArrowHolder alt="Esper Arrow" src={arrow} />
                  </LinkWrapper>
                </PostLink>
              )}
              <PostTile
                key={item.node.id}
                href={item.node.link.replace(
                  'https://esperdotblog.wpcomstaging.com/',
                  'https://blog.esper.io/'
                )}
                rel="noreferrer noopener"
                title={item.node.title.rendered}
              >
                <PostArticle className="post">
                  <HeaderImgTile
                    src={item.node.featuredImage}
                    alt={item.node.title.rendered}
                    title={item.node.title.rendered}
                  />
                  <PostTitle
                    className="black-color"
                    dangerouslySetInnerHTML={{
                      __html: `${item.node.title.rendered
                        .trim()
                        .substr(0, 80)
                        .trim()}${
                        item.node.title.rendered.trim().length > 80 ? '...' : ''
                      }`,
                    }}
                  />
                  <div className="categories-container tags-container post-meta-container margin-bottom-16px margin-left-categories">
                    <div
                      className="post-excerpt"
                      dangerouslySetInnerHTML={{
                        __html: `${item.node.excerpt.rendered
                          .split('')
                          .slice(0, 80)
                          .join('')}...`,
                      }}
                    />
                  </div>
                </PostArticle>
              </PostTile>
            </PostTileWrapper>
          ))}
          <PostTileWrapper>
            <PostLink
              href="https://esper.io/media-coverage"
              style={{ color: '#2d2b33' }}
              rel="noreferrer noopener"
              target="_blank"
            >
              <LinkWrapper>
                <LinkText> Esper in the News</LinkText>
                <ArrowHolder alt="Esper Arrow" src={arrow} />
              </LinkWrapper>
            </PostLink>
            <PostTile
              target="_blank"
              rel="noreferrer noopener"
              href="https://www.geekwire.com/2020/devops-iot-device-fleets-ex-microsoft-amazon-leaders-raise-7-6m-seattle-area-startup-esper/"
              title="DevOps for IoT device fleets: Ex-Microsoft, Amazon leaders raise $7.6M for Seattle-area startup Esper"
            >
              <PostArticle className="post" style={{ height: 'fit-content' }}>
                <HeaderImgTile
                  src={Geekwire}
                  alt="Geekwire"
                  title="DevOps for IoT device fleets: Ex-Microsoft, Amazon leaders raise $7.6M for Seattle-area startup Esper"
                />
                <PostTitle className="black-color">
                  DevOps for IoT device fleets: Ex-Microsoft, Amazon leaders
                  raise $7.6M for
                </PostTitle>
                <div
                  className="categories-container tags-container post-meta-container margin-bottom-16px margin-left-categories"
                  style={{ fontSize: '14px' }}
                >
                  <div
                    className="post-excerpt"
                    dangerouslySetInnerHTML={{
                      __html: `Founded in 2018, Esper is a DevOps platform for customers that manage fleets...`,
                    }}
                  />
                </div>
              </PostArticle>
            </PostTile>
          </PostTileWrapper>
        </CurrentUpdatesGridContainer>
      </CurrentUpdatesSection>
    )}
  />
);
